import React from 'react';
import TestimonialItem from './TestimonialItem';

const TestimonialsSlider = ({
    testimonials = [],
    variant = "photo", // "photo" or "image"
    sliderClass = "testimonials-slider",
    swiperClass = "swiper-testimonials"
}) => {
    return (
        <div id="testimonials" className="mxd-section overflow-hidden padding-default">
            <div className="mxd-container grid-container">
                <div className="mxd-block">
                    <div className={`${sliderClass} no-padding`}>
                        <div className={`${swiperClass} no-padding`}>
                            <div className="swiper-wrapper">
                                {testimonials.map((testimonial, index) => (
                                    <TestimonialItem
                                        key={index}
                                        name={testimonial.name}
                                        position={testimonial.position}
                                        company={testimonial.company}
                                        companyLink={testimonial.companyLink}
                                        rating={testimonial.rating}
                                        text={testimonial.text}
                                        avatar={testimonial.avatar}
                                        image={testimonial.image}
                                        buttonText={testimonial.buttonText}
                                        buttonLink={testimonial.buttonLink}
                                        variant={variant}
                                    />
                                ))}
                            </div>
                            <div className="swiper-testimonials__controls">
                                <div className="swiper-button-prev mxd-slider-btn mxd-slider-btn-round-prev">
                                    <a className="btn btn-round btn-round-small btn-outline slide-left anim-no-delay" href="#0">
                                        <i className="ph ph-arrow-left"></i>
                                    </a>
                                </div>
                                <div className="swiper-pagination mxd-swiper-pagination-fraction"></div>
                                <div className="swiper-button-next mxd-slider-btn mxd-slider-btn-round-next">
                                    <a className="btn btn-round btn-round-small btn-outline slide-right anim-no-delay" href="#0">
                                        <i className="ph ph-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialsSlider;
